import { useNavigate } from 'react-router-dom'

export default function DashboardMissplacedCheck() {
  const navigate = useNavigate()

  return (
    <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-6 mt-4'>
      <p className='font-bold text-2xl'>Missplaced Check</p>
      <p className='text-lg text-left'>Based on our system, it seems you have received your check. Please click the button below to generate a label and ship your check to us.</p>
      <button onClick={() => navigate('/missplaced-check')} className='px-6 py-3 bg-[#FF8C00] text-white font-semibold rounded-lg shadow hover:bg-[#e67600] transition'>
        Continue
      </button>
      <p className='text-sm text-gray-400 mt-2 text-center'>Thank you for your prompt attention.</p>
    </div>
  )
}